var _path, _rect, _rect2, _path2, _path3, _path4, _g, _rect3, _ellipse, _ellipse2, _rect4, _path5, _g2, _path6, _rect5, _rect6, _g3, _path7, _rect7, _g4, _path8, _path9, _rect8, _g5, _path10, _rect9, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect10, _rect11, _g6, _path22, _rect12, _g7, _path23, _path24, _rect13, _g8, _path25, _rect14, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _rect15, _rect16, _g9, _path37, _rect17, _g10, _path38, _path39, _rect18, _g11, _path40, _rect19, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScale3Tubes2Wet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 191,
    viewBox: "0 0 170 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2968 100.69C12.4876 98.8643 14.8232 97.7225 17.3671 97.7225H152.633C155.177 97.7225 157.512 98.8643 158.703 100.69L167.529 114.222C169.044 116.544 166.971 119.341 163.735 119.341H6.26463C3.02878 119.341 0.955955 116.544 2.47064 114.222L11.2968 100.69Z",
    fill: "#CCCCCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 151.3,
    y: 186.273,
    width: 17.5879,
    height: 4.12931,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.96533,
    y: 185.641,
    width: 17.5879,
    height: 4.12931,
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96533 146.319C1.96533 130.334 14.9238 117.376 30.9089 117.376H140.074C156.059 117.376 169.017 130.334 169.017 146.319V187.145H1.96533V146.319Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 121.128C0 115.799 4.3195 111.48 9.64787 111.48H160.352C165.68 111.48 170 115.799 170 121.128V185.179H0V121.128Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.364 168.409C149.364 173.738 145.045 178.057 139.716 178.057L29.3012 178.057C23.9728 178.057 19.6533 173.737 19.6533 168.409L19.6533 119.277L149.364 119.278L149.364 168.409Z",
    fill: "#CCD8E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9177_16875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.416 122.289H22.6011V153.891H146.416V122.289Z",
    fill: "#173E50"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.7556 122.289L34.1785 153.891H72.6147L132.587 122.289H93.7556Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.078 122.289L75.9858 153.891H80.1775L139.662 122.289H135.078Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.783 122.289H23.8875C23.177 122.289 22.6011 122.865 22.6011 123.575V154.246C22.6011 154.957 23.177 155.533 23.8875 155.533H147.783C148.493 155.533 149.069 154.957 149.069 154.246V123.575C149.069 122.865 148.493 122.289 147.783 122.289Z",
    stroke: "#031D29",
    strokeWidth: 2.57277,
    strokeMiterlimit: 10
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.1409,
    y: 102.212,
    width: 34.8025,
    height: 6.32038,
    fill: "#333333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.2258,
    cy: 95.8921,
    rx: 62.6445,
    ry: 11.3767,
    fill: "#838383"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.5422,
    cy: 93.9958,
    rx: 63.5937,
    ry: 12.0087,
    fill: "#5C5C5C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4987,
    y: 157.211,
    width: 39.8439,
    height: 17.6747,
    rx: 2.25117,
    fill: "#A41034",
    stroke: "#C87085",
    strokeWidth: 1.28638
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9177_16875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 156,
    width: 43,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.02 156.568V161.07V183.582H69.3578V175.22H64.8555L69.3578 170.718V161.07H101.517L106.02 156.568Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9177_16875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.4987,
    y: 157.211,
    width: 39.8439,
    height: 17.6747,
    rx: 2.25117,
    stroke: "#830D2A",
    strokeWidth: 1.28638
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3951 169.571V168.518L79.1956 164.61H76.5572V163.448H80.8705V164.493L78.07 168.41H80.9425V169.571H76.3951ZM83.783 169.679C82.3603 169.679 81.6399 169.004 81.6399 167.68V166.762C81.6399 165.456 82.3603 164.763 83.729 164.763C85.1067 164.763 85.8271 165.474 85.8271 166.78V167.635H82.9726V167.725C82.9726 168.338 83.2158 168.635 83.7921 168.635C84.2423 168.635 84.5034 168.455 84.5304 168.131H85.8001C85.7461 169.148 85.0527 169.679 83.783 169.679ZM82.9726 166.699H84.5665C84.5665 166.069 84.3323 165.807 83.774 165.807C83.2067 165.807 82.9726 166.069 82.9726 166.699ZM86.7882 169.571V164.871H87.9228L87.9768 165.744C88.1569 165.078 88.5261 164.781 89.1745 164.781H89.5256V166.024H89.2735C88.5802 166.024 88.247 166.285 88.1209 166.942V169.571H86.7882ZM92.1456 169.679C90.7228 169.679 90.0115 169.004 90.0115 167.653V166.789C90.0115 165.438 90.7228 164.763 92.1456 164.763C93.5683 164.763 94.2797 165.438 94.2797 166.789V167.653C94.2797 169.004 93.5683 169.679 92.1456 169.679ZM92.1456 168.599C92.7129 168.599 92.947 168.311 92.947 167.626V166.816C92.947 166.132 92.7129 165.843 92.1456 165.843C91.5783 165.843 91.3442 166.132 91.3442 166.816V167.626C91.3442 168.311 91.5783 168.599 92.1456 168.599Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 95,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 52 95)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9177_16875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 79,
    width: 38,
    height: 14
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 93,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 54 93)",
    fill: "#99DFF9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9177_16875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 93,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 54 93)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8846 91.2788C57.0823 91.2788 54 88.1965 54 84.3943C54 80.592 57.0823 77.5097 60.8846 77.5097L92.9744 77.5097L92.9744 87.2788C92.9744 89.488 91.1835 91.2788 88.9744 91.2788L60.8846 91.2788Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 81L52 78L93 78L93 81L52 81Z",
    fill: "#F2F7FC"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1072 90.0282C45.45 90.5368 44.4951 90.0684 44.4951 89.2374L44.4951 83.2082C44.4951 82.4106 45.3832 81.934 46.0479 82.3749L50.109 85.069L50.109 86.931L46.1072 90.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9177_16875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 83,
    width: 3,
    height: 6
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52.604,
    y: 83.8276,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 52.604 83.8276)",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9177_16875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.604,
    y: 83.8276,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 52.604 83.8276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.81 83.2069C51.1313 83.2069 51.41 83.4255 51.4661 83.7419C51.556 84.2482 51.6685 85.0682 51.6685 86C51.6685 86.9318 51.556 87.7517 51.4661 88.2581C51.41 88.5745 51.1313 88.7931 50.81 88.7931C50.4229 88.7931 50.1091 88.4793 50.1091 88.0922L50.1091 83.9078C50.1091 83.5207 50.4229 83.2069 50.81 83.2069Z",
    fill: "#EEEEEE"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3574 89.5149C42.7027 89.7655 42 89.2821 42 88.581L42 83.9382C42 83.266 42.65 82.7852 43.2928 82.982L50.1089 85.0689L50.1089 86.931L43.3574 89.5149Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.893 90.0282C101.55 90.5368 102.505 90.0684 102.505 89.2374L102.505 83.2082C102.505 82.4106 101.617 81.934 100.952 82.3749L96.891 85.069L96.891 86.931L100.893 90.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9177_16875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 83,
    width: 3,
    height: 6
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 94.396 83.8276)",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9177_16875)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 94.396 83.8276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19 83.2069C95.8687 83.2069 95.59 83.4255 95.5339 83.7419C95.444 84.2482 95.3315 85.0682 95.3315 86C95.3315 86.9318 95.444 87.7517 95.5339 88.2581C95.59 88.5745 95.8687 88.7931 96.19 88.7931C96.5771 88.7931 96.8909 88.4793 96.8909 88.0922L96.8909 83.9078C96.8909 83.5207 96.5771 83.2069 96.19 83.2069Z",
    fill: "#EEEEEE"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.643 89.5149C104.297 89.7655 105 89.2821 105 88.581L105 83.9382C105 83.266 104.35 82.7852 103.707 82.982L96.8911 85.0689L96.8911 86.931L103.643 89.5149Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 77,
    width: 18,
    height: 12,
    transform: "rotate(90 80 77)",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3906 90.5L72.3906 89.504L74.3946 89.504L74.3946 83.732C73.7226 84.2 72.9546 84.296 72.1506 84.32L72.1506 83.384C73.1826 83.348 73.9026 83.036 74.4426 82.34L75.4506 82.34L75.4506 89.504L77.4546 89.504L77.4546 90.5L72.3906 90.5Z",
    fill: "#333333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7367 89.2368C59.7367 89.9781 59.1358 90.5789 58.3946 90.5789C57.6534 90.5789 57.0525 89.9781 57.0525 89.2368C57.0525 88.4956 58.3946 87 58.3946 87C58.3946 87 59.7367 88.4956 59.7367 89.2368Z",
    fill: "#00AEEF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7763 92.2368C65.7763 92.9781 65.1754 93.5789 64.4341 93.5789C63.6929 93.5789 63.092 92.9781 63.092 92.2368C63.092 91.4956 64.4341 90 64.4341 90C64.4341 90 65.7763 91.4956 65.7763 92.2368Z",
    fill: "#00AEEF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5656 81.2368C84.5656 81.9781 83.9647 82.5789 83.2235 82.5789C82.4822 82.5789 81.8813 81.9781 81.8813 81.2368C81.8813 80.4956 83.2235 79 83.2235 79C83.2235 79 84.5656 80.4956 84.5656 81.2368Z",
    fill: "#00AEEF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2894 90.1842C93.2894 90.9255 92.6886 91.5263 91.9473 91.5263C91.2061 91.5263 90.6052 90.9255 90.6052 90.1842C90.6052 89.443 91.9473 87.9474 91.9473 87.9474C91.9473 87.9474 93.2894 89.443 93.2894 90.1842Z",
    fill: "#00AEEF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8814 89.8174C81.8814 90.4197 81.3806 90.9079 80.763 90.9079C80.1453 90.9079 79.6445 90.4197 79.6445 89.8174C79.6445 89.2152 80.763 88 80.763 88C80.763 88 81.8814 89.2152 81.8814 89.8174Z",
    fill: "#00AEEF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8815 82.3552C64.8815 83.0965 64.2806 83.6974 63.5394 83.6974C62.7981 83.6974 62.1973 83.0965 62.1973 82.3552C62.1973 81.614 63.5394 80.1184 63.5394 80.1184C63.5394 80.1184 64.8815 81.614 64.8815 82.3552Z",
    fill: "#00AEEF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9999 88.398C48.9999 88.8613 48.5993 89.2368 48.1052 89.2368C47.611 89.2368 47.2104 88.8613 47.2104 88.398C47.2104 87.9348 48.1052 87 48.1052 87C48.1052 87 48.9999 87.9348 48.9999 88.398Z",
    fill: "#00AEEF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0263 87.398C87.0263 87.8613 86.6257 88.2368 86.1316 88.2368C85.6374 88.2368 85.2368 87.8613 85.2368 87.398C85.2368 86.9348 86.1316 86 86.1316 86C86.1316 86 87.0263 86.9348 87.0263 87.398Z",
    fill: "#00AEEF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9999 84.648C99.9999 85.1113 99.5993 85.4868 99.1052 85.4868C98.611 85.4868 98.2104 85.1113 98.2104 84.648C98.2104 84.1848 99.1052 83.25 99.1052 83.25C99.1052 83.25 99.9999 84.1848 99.9999 84.648Z",
    fill: "#00AEEF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0395 85.0954C55.0395 85.5587 54.6389 85.9342 54.1447 85.9342C53.6506 85.9342 53.25 85.5587 53.25 85.0954C53.25 84.6321 54.1447 83.6974 54.1447 83.6974C54.1447 83.6974 55.0395 84.6321 55.0395 85.0954Z",
    fill: "#00AEEF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 95,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 75 95)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9177_16875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 79,
    width: 38,
    height: 14
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 93,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 77 93)",
    fill: "#99DFF9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9177_16875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 93,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 77 93)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8846 91.2788C80.0823 91.2788 77 88.1965 77 84.3943C77 80.592 80.0823 77.5097 83.8846 77.5097L115.974 77.5097L115.974 87.2788C115.974 89.488 114.183 91.2788 111.974 91.2788L83.8846 91.2788Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 81L75 78L116 78L116 81L75 81Z",
    fill: "#F2F7FC"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1072 90.0282C68.45 90.5368 67.4951 90.0684 67.4951 89.2374L67.4951 83.2082C67.4951 82.4106 68.3832 81.934 69.0479 82.3749L73.109 85.069L73.109 86.931L69.1072 90.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9177_16875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 83,
    width: 3,
    height: 6
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 75.604,
    y: 83.8276,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 75.604 83.8276)",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9177_16875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.604,
    y: 83.8276,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 75.604 83.8276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.81 83.2069C74.1313 83.2069 74.41 83.4255 74.4661 83.7419C74.556 84.2482 74.6685 85.0682 74.6685 86C74.6685 86.9318 74.556 87.7517 74.4661 88.2581C74.41 88.5745 74.1313 88.7931 73.81 88.7931C73.4229 88.7931 73.1091 88.4793 73.1091 88.0922L73.1091 83.9078C73.1091 83.5207 73.4229 83.2069 73.81 83.2069Z",
    fill: "#EEEEEE"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3574 89.5149C65.7027 89.7655 65 89.2821 65 88.581L65 83.9382C65 83.266 65.65 82.7852 66.2928 82.982L73.1089 85.0689L73.1089 86.931L66.3574 89.5149Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M123.893 90.0282C124.55 90.5368 125.505 90.0684 125.505 89.2374L125.505 83.2082C125.505 82.4106 124.617 81.934 123.952 82.3749L119.891 85.069L119.891 86.931L123.893 90.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_9177_16875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 83,
    width: 3,
    height: 6
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 117.396 83.8276)",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_9177_16875)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 117.396 83.8276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.19 83.2069C118.869 83.2069 118.59 83.4255 118.534 83.7419C118.444 84.2482 118.332 85.0682 118.332 86C118.332 86.9318 118.444 87.7517 118.534 88.2581C118.59 88.5745 118.869 88.7931 119.19 88.7931C119.577 88.7931 119.891 88.4793 119.891 88.0922L119.891 83.9078C119.891 83.5207 119.577 83.2069 119.19 83.2069Z",
    fill: "#EEEEEE"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M126.643 89.5149C127.297 89.7655 128 89.2821 128 88.581L128 83.9382C128 83.266 127.35 82.7852 126.707 82.982L119.891 85.0689L119.891 86.931L126.643 89.5149Z",
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 77,
    width: 18,
    height: 12,
    transform: "rotate(90 103 77)",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3906 90.5L95.3906 89.504L97.3946 89.504L97.3946 83.732C96.7226 84.2 95.9546 84.296 95.1506 84.32L95.1506 83.384C96.1826 83.348 96.9026 83.036 97.4426 82.34L98.4506 82.34L98.4506 89.504L100.455 89.504L100.455 90.5L95.3906 90.5Z",
    fill: "#333333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7367 89.2368C82.7367 89.9781 82.1358 90.5789 81.3946 90.5789C80.6534 90.5789 80.0525 89.9781 80.0525 89.2368C80.0525 88.4956 81.3946 87 81.3946 87C81.3946 87 82.7367 88.4956 82.7367 89.2368Z",
    fill: "#00AEEF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7763 92.2368C88.7763 92.9781 88.1754 93.5789 87.4341 93.5789C86.6929 93.5789 86.092 92.9781 86.092 92.2368C86.092 91.4956 87.4341 90 87.4341 90C87.4341 90 88.7763 91.4956 88.7763 92.2368Z",
    fill: "#00AEEF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.566 81.2368C107.566 81.9781 106.965 82.5789 106.223 82.5789C105.482 82.5789 104.881 81.9781 104.881 81.2368C104.881 80.4956 106.223 79 106.223 79C106.223 79 107.566 80.4956 107.566 81.2368Z",
    fill: "#00AEEF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M116.289 90.1842C116.289 90.9255 115.689 91.5263 114.947 91.5263C114.206 91.5263 113.605 90.9255 113.605 90.1842C113.605 89.443 114.947 87.9474 114.947 87.9474C114.947 87.9474 116.289 89.443 116.289 90.1842Z",
    fill: "#00AEEF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M104.881 89.8174C104.881 90.4197 104.381 90.9079 103.763 90.9079C103.145 90.9079 102.645 90.4197 102.645 89.8174C102.645 89.2152 103.763 88 103.763 88C103.763 88 104.881 89.2152 104.881 89.8174Z",
    fill: "#00AEEF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8815 82.3552C87.8815 83.0965 87.2806 83.6974 86.5394 83.6974C85.7981 83.6974 85.1973 83.0965 85.1973 82.3552C85.1973 81.614 86.5394 80.1184 86.5394 80.1184C86.5394 80.1184 87.8815 81.614 87.8815 82.3552Z",
    fill: "#00AEEF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9999 88.398C71.9999 88.8613 71.5993 89.2368 71.1052 89.2368C70.611 89.2368 70.2104 88.8613 70.2104 88.398C70.2104 87.9348 71.1052 87 71.1052 87C71.1052 87 71.9999 87.9348 71.9999 88.398Z",
    fill: "#00AEEF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M110.026 87.398C110.026 87.8613 109.626 88.2368 109.132 88.2368C108.637 88.2368 108.237 87.8613 108.237 87.398C108.237 86.9348 109.132 86 109.132 86C109.132 86 110.026 86.9348 110.026 87.398Z",
    fill: "#00AEEF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M123 84.648C123 85.1113 122.599 85.4868 122.105 85.4868C121.611 85.4868 121.21 85.1113 121.21 84.648C121.21 84.1848 122.105 83.25 122.105 83.25C122.105 83.25 123 84.1848 123 84.648Z",
    fill: "#00AEEF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0395 85.0954C78.0395 85.5587 77.6389 85.9342 77.1447 85.9342C76.6506 85.9342 76.25 85.5587 76.25 85.0954C76.25 84.6321 77.1447 83.6974 77.1447 83.6974C77.1447 83.6974 78.0395 84.6321 78.0395 85.0954Z",
    fill: "#00AEEF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 100,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 63 100)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_9177_16875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 84,
    width: 38,
    height: 14
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 98,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 65 98)",
    fill: "#99DFF9"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_9177_16875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 98,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 65 98)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8846 96.2788C68.0823 96.2788 65 93.1965 65 89.3943C65 85.592 68.0823 82.5097 71.8846 82.5097L103.974 82.5097L103.974 92.2788C103.974 94.488 102.183 96.2788 99.9744 96.2788L71.8846 96.2788Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 86L63 83L104 83L104 86L63 86Z",
    fill: "#F2F7FC"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1072 95.0282C56.45 95.5368 55.4951 95.0684 55.4951 94.2374L55.4951 88.2082C55.4951 87.4106 56.3832 86.934 57.0479 87.3749L61.109 90.069L61.109 91.931L57.1072 95.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_9177_16875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 88,
    width: 3,
    height: 6
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 63.604,
    y: 88.8276,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 63.604 88.8276)",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_9177_16875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.604,
    y: 88.8276,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 63.604 88.8276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.81 88.2069C62.1313 88.2069 62.41 88.4255 62.4661 88.7419C62.556 89.2482 62.6685 90.0682 62.6685 91C62.6685 91.9318 62.556 92.7517 62.4661 93.2581C62.41 93.5745 62.1313 93.7931 61.81 93.7931C61.4229 93.7931 61.1091 93.4793 61.1091 93.0922L61.1091 88.9078C61.1091 88.5207 61.4229 88.2069 61.81 88.2069Z",
    fill: "#EEEEEE"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3574 94.5149C53.7027 94.7655 53 94.2821 53 93.581L53 88.9382C53 88.266 53.65 87.7852 54.2928 87.982L61.1089 90.0689L61.1089 91.931L54.3574 94.5149Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M111.893 95.0282C112.55 95.5368 113.505 95.0684 113.505 94.2374L113.505 88.2082C113.505 87.4106 112.617 86.934 111.952 87.3749L107.891 90.069L107.891 91.931L111.893 95.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_9177_16875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 88,
    width: 3,
    height: 6
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 105.396 88.8276)",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_9177_16875)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 105.396 88.8276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.19 88.2069C106.869 88.2069 106.59 88.4255 106.534 88.7419C106.444 89.2482 106.332 90.0682 106.332 91C106.332 91.9318 106.444 92.7517 106.534 93.2581C106.59 93.5745 106.869 93.7931 107.19 93.7931C107.577 93.7931 107.891 93.4793 107.891 93.0922L107.891 88.9078C107.891 88.5207 107.577 88.2069 107.19 88.2069Z",
    fill: "#EEEEEE"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M114.643 94.5149C115.297 94.7655 116 94.2821 116 93.581L116 88.9382C116 88.266 115.35 87.7852 114.707 87.982L107.891 90.0689L107.891 91.931L114.643 94.5149Z",
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 82,
    width: 18,
    height: 12,
    transform: "rotate(90 91 82)",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6946 95.5L82.6946 94.888C82.6946 93.376 83.4146 92.476 85.3226 91.6C86.7626 90.94 87.2666 90.4 87.2666 89.548C87.2666 88.696 86.7266 88.156 85.5986 88.156C84.4586 88.156 83.8466 88.696 83.8466 89.788L83.8466 89.956L82.8146 89.956L82.8146 89.68C82.8146 88.072 83.8346 87.196 85.6106 87.196C87.3866 87.196 88.3226 88.096 88.3226 89.524C88.3226 90.82 87.6386 91.612 85.8266 92.428C84.3266 93.1 83.7866 93.628 83.7386 94.504L88.2986 94.504L88.2986 95.5L82.6946 95.5Z",
    fill: "#333333"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7367 94.2368C70.7367 94.9781 70.1358 95.5789 69.3946 95.5789C68.6534 95.5789 68.0525 94.9781 68.0525 94.2368C68.0525 93.4956 69.3946 92 69.3946 92C69.3946 92 70.7367 93.4956 70.7367 94.2368Z",
    fill: "#00AEEF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7763 97.2368C76.7763 97.9781 76.1754 98.5789 75.4341 98.5789C74.6929 98.5789 74.092 97.9781 74.092 97.2368C74.092 96.4956 75.4341 95 75.4341 95C75.4341 95 76.7763 96.4956 76.7763 97.2368Z",
    fill: "#00AEEF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5656 86.2368C95.5656 86.9781 94.9647 87.5789 94.2235 87.5789C93.4822 87.5789 92.8813 86.9781 92.8813 86.2368C92.8813 85.4956 94.2235 84 94.2235 84C94.2235 84 95.5656 85.4956 95.5656 86.2368Z",
    fill: "#00AEEF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M104.289 95.1842C104.289 95.9255 103.689 96.5263 102.947 96.5263C102.206 96.5263 101.605 95.9255 101.605 95.1842C101.605 94.443 102.947 92.9474 102.947 92.9474C102.947 92.9474 104.289 94.443 104.289 95.1842Z",
    fill: "#00AEEF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8814 94.8174C92.8814 95.4197 92.3806 95.9079 91.763 95.9079C91.1453 95.9079 90.6445 95.4197 90.6445 94.8174C90.6445 94.2152 91.763 93 91.763 93C91.763 93 92.8814 94.2152 92.8814 94.8174Z",
    fill: "#00AEEF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8815 87.3552C75.8815 88.0965 75.2806 88.6974 74.5394 88.6974C73.7981 88.6974 73.1973 88.0965 73.1973 87.3552C73.1973 86.614 74.5394 85.1184 74.5394 85.1184C74.5394 85.1184 75.8815 86.614 75.8815 87.3552Z",
    fill: "#00AEEF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 93.398C59.9999 93.8613 59.5993 94.2368 59.1052 94.2368C58.611 94.2368 58.2104 93.8613 58.2104 93.398C58.2104 92.9348 59.1052 92 59.1052 92C59.1052 92 59.9999 92.9348 59.9999 93.398Z",
    fill: "#00AEEF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0263 92.398C98.0263 92.8613 97.6257 93.2368 97.1316 93.2368C96.6374 93.2368 96.2368 92.8613 96.2368 92.398C96.2368 91.9348 97.1316 91 97.1316 91C97.1316 91 98.0263 91.9348 98.0263 92.398Z",
    fill: "#00AEEF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M111 89.648C111 90.1113 110.599 90.4868 110.105 90.4868C109.611 90.4868 109.21 90.1113 109.21 89.648C109.21 89.1848 110.105 88.25 110.105 88.25C110.105 88.25 111 89.1848 111 89.648Z",
    fill: "#00AEEF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0395 90.0954C66.0395 90.5587 65.6389 90.9342 65.1447 90.9342C64.6506 90.9342 64.25 90.5587 64.25 90.0954C64.25 89.6321 65.1447 88.6974 65.1447 88.6974C65.1447 88.6974 66.0395 89.6321 66.0395 90.0954Z",
    fill: "#00AEEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9177_16875"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.6011,
    y: 122.289,
    width: 123.815,
    height: 31.6019,
    rx: 1.28638,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale3Tubes2Wet);
export default __webpack_public_path__ + "static/media/Scale_3Tubes_2_wet.a243c9e26c92aa7daa77b7997d40070f.svg";
export { ForwardRef as ReactComponent };